import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=1e65681a&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=ts&"
export * from "./slider.vue?vue&type=script&lang=ts&"
import style0 from "./slider.vue?vue&type=style&index=0&id=1e65681a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65681a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e65681a')) {
      api.createRecord('1e65681a', component.options)
    } else {
      api.reload('1e65681a', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=1e65681a&scoped=true&", function () {
      api.rerender('1e65681a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/blog/slider.vue"
export default component.exports